import Colors from 'enums/Colors';
import { fetchStorageFile } from 'hooks/StoreFiles';
import React from 'react';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        width: 280px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: ${Colors.White};
        text-align: center;
        padding: 10px;
        border-radius: 20px;

        p {
            font-size: 14px !important;
        }
    `,
};


interface CardQRcodeVideosPlanoAnualProps {
    styles?: React.CSSProperties;
}
const CardQRcodeVideosPlanoAnual: React.FC<CardQRcodeVideosPlanoAnualProps> = ({ styles }) => {
    return (
        <Styled.Container style={styles}>
            <p>Acesse os vídeos no QR Code abaixo para conhecer mais sobre essas histórias</p>
            <img
            style={{width: "150px"}}
                src={fetchStorageFile('anexo_storage_files_2013538873254643417.jpg_2025-11-26-1764156919733.jpg')}
                alt="Acesse os vídeos no QR Code abaixo para conhecer mais sobre essas histórias"
            />
        </Styled.Container>
    );
};

export default CardQRcodeVideosPlanoAnual;
